import { CompletedSessionsDTO, convertCompletedSessionsFromDto } from "@modules/completedSessions/completedSessionsDto"
import { Periodicity } from "@modules/completedSessions/completedSessionsType"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { PublicProfileDto } from "@modules/profile/publicProfile/publicProfileDto"
import { PublicProfileApiGateway } from "@modules/profile/publicProfile/services/publicProfileApi.gateway"

/**
 * PublicProfileApi class
 *
 * This class provides methods for interacting with user-related API endpoints.
 * It handles operations such as retrieving user profiles and completed sessions.
 *
 * @class
 */
export class PublicProfileApi implements PublicProfileApiGateway {
  private baseUrl = "/users"
  constructor(protected readonly api: ApiClient) {}

  /**
   * Retrieves a user's public profile
   * @param profileId - The ID of the user profile to retrieve
   * @returns A Promise that resolves to a PublicProfile object
   */
  async getProfile(profileId: string): Promise<PublicProfileDto> {
    const result = await this.api.get<PublicProfileDto>(`${this.baseUrl}/${profileId}`)
    return result.data
  }

  /**
   * Retrieves a user's completed sessions
   * @param id - The ID of the user
   * @param periodicity - The periodicity of the completed sessions
   * @param limit - The maximum number of completed sessions to retrieve
   * @returns A Promise that resolves to an array of converted CompletedSessions objects
   */
  async getCompletedSessions(id: string, periodicity: Periodicity, limit: number) {
    const url = `${this.baseUrl}/${id}/completed-sessions?periodicity=${periodicity}${limit > 0 ? `&limit=${limit}` : ""}`
    // By default, the max completed sessions return by the back is 8
    const result = await this.api.get<CompletedSessionsDTO[]>(url)
    return result.data.map((completedSessionsDTO) => convertCompletedSessionsFromDto(completedSessionsDTO))
  }
}
